"use strict";

class HomeController {
    /*@ngInject*/
    constructor($state, $stateParams, inventory, iconCache, $mdDialog, orderStore, utils, $q, auth) {
        "ngInject";
        _.extend(this, {
            name: 'home',
            $state: $state,
            $stateParams: $stateParams,
            $mdDialog: $mdDialog,
            inventory: inventory,
            getIconFor: iconCache,
            orderStore: orderStore,
            utils: utils,
            $q: $q,
            auth: auth
        });

        this.orderLoader = this.orderStore.getOrderWithRedirectionCheck($stateParams.orderId, false)
            .then(
                (order) => this.initialize(order),
                (error) => this.$q.reject(error)
            );
    }

    initialize(order) {
        this.order = order;
        this.flatOrderItems = this.utils.flattenOrderItems(this.order.order_items, this.order.item_stats, this.order.vehicle_statistics, this.order.property_type);
        this.itemColumns = this.getItemColumnsFromInventory(this.flatOrderItems);
        this.showHelpText = true;
    }

    getItemColumnsFromInventory(inventory) {
        let primaryItemsInInventory = _(inventory)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .filter(item => this.utils.isInPrimaryCategory(item))
            .value();

        let primaryRootItems = _.filter(
            this.inventory.getPrimaryRootItems(),
            (root) => {
                if (this.order.property_type === 'VEHICLE') {
                    return _.contains(root.name, 'vehicle');
                }
                return true;
            }
        );

        return _(primaryRootItems)
            .map(rootCategory => this.utils.getItemColumn(rootCategory.qualifiedName, []))
            .sortBy(category => this.utils.sortMajorCategories(category))
            .map(rootCategory => {
                let matchingExistingItemsInInventory = _.filter(primaryItemsInInventory, (item) =>
                    this.utils.compareQualifiedNameOf(item, rootCategory.qualifiedName, 1));
                rootCategory.children = matchingExistingItemsInInventory;
                return rootCategory;
            })
            .map(rootCategory => this.utils.withCountsOf(rootCategory.children, rootCategory, 2))
            .map(rootCategory => this.utils.withAllUniqueItemsFromRootOf(rootCategory, 2))
            .value();
    }

    onItemClick(evt) {
        let action = evt.action,
            selectedItem = evt.item,
            selectedItemColumn = evt.column;

        let selectedItemQualifiedName = selectedItem.qualifiedName;
        switch (action) {
            case 'add':
                selectedItemColumn.children.push(this.inventory.getItemWithQualifiedName(selectedItemQualifiedName));
                this.utils.updateCountsOf(selectedItemColumn, this.itemColumns, 2);
                break;
            case 'subtract':
                // Remove item from itemColumn
                let indexOfSimilarItemInColumn = _.findLastIndex(selectedItemColumn.children, (item) =>
                    _.isUndefined(item.id) && _.isUndefined(item._destroy) && this.utils.compareQualifiedNameOf(item, selectedItemQualifiedName, 2)
                );
                if (indexOfSimilarItemInColumn !== -1) {
                    let itemFromColumn = selectedItemColumn.children[indexOfSimilarItemInColumn];
                    if (itemFromColumn.order_item_id) {
                        itemFromColumn._destroy = true;
                    } else {
                        selectedItemColumn.children.splice(indexOfSimilarItemInColumn, 1);
                    }
                }

                // Handle deletion of persisted items
                const allSimilarPersistedItems = _.filter(selectedItemColumn.children, (item) =>
                    item.id && this.utils.compareQualifiedNameOf(item, selectedItemQualifiedName, 2)
                );
                if (indexOfSimilarItemInColumn === -1 && allSimilarPersistedItems.length > 0) {
                    return this.showDeleteItemsModal(allSimilarPersistedItems, selectedItemColumn);
                }

                this.utils.updateCountsOf(selectedItemColumn, this.itemColumns, 2);
                break;
        }
    }

    showLoginModal() {
        this.auth.showLoginModal();
    }

    showDeleteItemsModal(removableItems, selectedItemColumn) {
        this.$mdDialog.show({
                controller: require('common/popup.component/delete.items/delete.items.controller'),
                controllerAs: 'items',
                template: require('common/popup.component/delete.items/delete.items.html'),
                locals: {
                  removableItems: removableItems
                },
                parent: angular.element(document.body),
                clickOutsideToClose: true
            })
            .then((newItemSet) => {
                let itemsToRemove = [];
                _.forEach(newItemSet, (item) => {
                    let itemFromOrder = _.find(this.flatOrderItems, (toDestroy) =>
                        _.isUndefined(toDestroy._destroy) && toDestroy.id === item.id && _.indexOf(itemsToRemove, toDestroy) === -1);
                    if (itemFromOrder && item._destroy) {
                        itemsToRemove.push(itemFromOrder);
                    }
                });
                _.forEach(itemsToRemove, (item) => {
                    const allSimilarItemsInFlatItems = _.filter(this.flatOrderItems, (flatItem) => flatItem.id === item.id);
                    /**
                     * If the number of similar items >= 1
                     *  remove ONE arbitrary item from flat order items
                     * If the number of similar items === 1
                     *  mark the item as destroyed
                     */
                    const indexOfItemInFlatItems = _.indexOf(this.flatOrderItems, item);
                    const indexOfItemInSelectedItemColumn = _.indexOf(selectedItemColumn.children, item);
                    if (allSimilarItemsInFlatItems.length > 1) {
                        if (indexOfItemInFlatItems !== -1) {
                            this.flatOrderItems.splice(indexOfItemInFlatItems, 1);
                        }
                        if (indexOfItemInSelectedItemColumn !== -1) {
                            selectedItemColumn.children.splice(indexOfItemInSelectedItemColumn, 1);
                        }
                    }
                    if (allSimilarItemsInFlatItems.length === 1) {
                        this.flatOrderItems[indexOfItemInFlatItems]._destroy = true;
                    }
                });
                this.utils.updateCountsOf(selectedItemColumn, this.itemColumns, 2);
            });
    }

    getUpdatedOrder(status) {
        let secondaryItemsInInventory = _(this.flatOrderItems)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .filter(item => !this.utils.isInPrimaryCategory(item))
            .value();
        let updatedInventoryItems = _(this.itemColumns).pluck('children').flatten().value().concat(secondaryItemsInInventory);
        let mergedInventoryItems = this.utils.mergeOrderItems(updatedInventoryItems);

        let order = _.cloneDeep(this.order);
        order.order_items = mergedInventoryItems;
        order.order_time = parseInt(new Date(order.order_time * 1000).getTime() / 1000, 10);
        order.status = status;

        return order;
    }

    goToSpecifications() {
        this.orderLoader = this.orderStore.saveOrder(this.getUpdatedOrder(this.orderStore.status.DRAFTED))
            .then(
                (order) => {
                    let nextState;
                    /**
                     * If there are ZERO order items,
                     *  go to others page
                     * else go to specifications page
                     */
                    if (_.isEmpty(order.order_items)) {
                        nextState = this.utils.getAdminStateIfApplicable('base.others');
                        return this.$state.go(nextState, {orderId: order.id});
                    }

                    nextState = this.utils.getAdminStateIfApplicable('base.specifications');
                    this.$state.go(nextState, {orderId: order.id});
                },
                (error) => console.log(error)
            );
    }

    skipMajorItems(evt) {

        this.$mdDialog.show({
                controller($scope, $mdDialog) {
                    "ngInject";
                    $scope.cancel = function() {
                        $mdDialog.cancel();
                    };
                    $scope.proceed = function(continueWithIncompleteDetails) {
                        $mdDialog.hide(continueWithIncompleteDetails);
                    };
                },
                template: require('common/popup.component/skip.popup.html'),
                parent: angular.element(document.body),
                targetEvent: evt,
                clickOutsideToClose: true
            })
            .then((continueWithIncompleteDetails) => {
                let updatedOrder = this.getUpdatedOrder(this.orderStore.status.DRAFTED);
                updatedOrder.is_skipped = true;
                woopra.track("skip-option-availed", {
                    order_id : this.order.id
                });

                /**
                 * If we have the user's contact details,
                 *  save order and continue to acknowledgement page.
                 *
                 * Else, take the user to the contact details page.
                 * Once the details have been confirmed,
                 *  go to acknowledgement page.
                 */

                this.orderLoader = this.orderStore.saveOrder(updatedOrder, true)
                    .then(
                        (order) => {
                            let nextState, redirectState;
                            if (this.auth.isAuthenticated()) {
                                this.$state.go('base.acknowledge', {orderId: order.id});
                            } else if (this.auth.isAdminUser() && !order.user_id) {
                                nextState = this.utils.getAdminStateIfApplicable('base.login');
                                this.$state.go(nextState, {orderId: order.id});
                            } else {
                                redirectState = this.utils.getAdminStateIfApplicable('base.acknowledge');
                                nextState = this.utils.getAdminStateIfApplicable('base.login');
                                this.$state.go(nextState, {orderId: order.id}, redirectState);
                            }
                        },
                        (error) => console.log(error)
                    );
            });
    }


    saveAsDraft() {
        let updatedOrder = this.getUpdatedOrder(this.orderStore.status.DRAFTED);

        /**
         * If we have the user's contact details,
         * save order and stay on page.
         *
         * Else, take the user to the contact details page.
         * Once the details have been confirmed,
         *  redirect the user to this page.
         */

        this.orderLoader = this.orderStore.saveOrder(updatedOrder, true)
            .then(
                (order) => {
                    if (this.auth.isAuthenticated() || (this.auth.isAdminUser() && updatedOrder.user_id)) {
                        this.utils.showAlertPopup('Order Saved!', 'Order Saved', 'Your order has been saved')
                            .then(() => {
                                this.initialize(order);
                                let nextState = this.utils.getAdminStateIfApplicable('base.home');
                                this.$state.go(nextState, {orderId: order.id});
                            });
                    } else {
                        let nextState = this.utils.getAdminStateIfApplicable('base.login'),
                            redirectState = this.utils.getAdminStateIfApplicable('base.home');
                        this.$state.go(nextState, {orderId: this.order.id, redirect: redirectState, showSavePopup: true});
                    }
                },
                (error) => {
                    console.log(error);
                    return error;
                }
            );

    }

}

export default HomeController;



// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js